import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';

type QueryGraphQLError = Error & {
	path?: ReadonlyArray<number | string>;
};

type QueryErrorWithGraphQLErrors = Error & {
	graphQLErrors?: ReadonlyArray<QueryGraphQLError>;
	networkError?: Error | null;
};

export const isSpaceDenialOnly = (error: Error | undefined): boolean => {
	if (!error) {
		return false;
	}

	const { graphQLErrors = [], networkError } = error as QueryErrorWithGraphQLErrors;
	return (
		graphQLErrors.length > 0 &&
		!networkError &&
		graphQLErrors.every(
			(graphQLError) =>
				isUnauthorizedError(graphQLError) &&
				graphQLError.path?.length === 1 &&
				graphQLError.path[0] === 'space',
		)
	);
};
